import script from "./FundsCompany.vue?vue&type=script&setup=true&lang=js"
export * from "./FundsCompany.vue?vue&type=script&setup=true&lang=js"

import "./FundsCompany.vue?vue&type=style&index=0&id=4902826d&scoped=true&lang=scss"
import "./FundsCompany.vue?vue&type=style&index=1&id=4902826d&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4902826d"]])

export default __exports__